import React, { useState, useEffect }  from "react";
import colors from "theme/foundations/colors.style";
import { Box, SimpleGrid, AspectRatio, VStack } from "@chakra-ui/react";
import useSelectedParticipant from "context/session/VideoProvider/useSelectedParticipant";
import { useParticipants, useVideoContext } from "hooks/session";
import useGameLiftStreams from "hooks/session/useGameLiftStreams";
import Participant from "./Participant";
import GameLiftStreamsElement from "./GameLiftStreams";

interface Props {
    changeFocus: (participant: any) => void;
    sessionId: any;
}

const CallOverlay: React.FC<Props> = ({ changeFocus, sessionId }: Props) => {
    const participants = useParticipants();
    const [selectedParticipant,] = useSelectedParticipant();
    const { gameFocused, gameStarted } = useGameLiftStreams(sessionId);
    const {room,} = useVideoContext();

    if (!room) return null;

    const gameOverlay = () => {
        if (gameStarted && !gameFocused) {
            return (
                <Box
                    borderRadius="10px"
                    overflow="hidden"
                    position="relative"
                    height="full"
                    onClick={() => { changeFocus(null); /* console.log("Clicked mini gamecast"); */ }}  /*Only do click event if the game is not focused*/
                >
                    <AspectRatio ratio={10 / 6}>
                        <GameLiftStreamsElement sessionId={sessionId} />
                    </AspectRatio>
                    <Box
                        bgColor={colors.blueAlpha[600]}
                        borderRadius="10px"
                        bottom="2.5rem"
                        color={colors.white}
                        fontSize="small"
                        left="0.4rem"
                        maxWidth="fit-content"
                        mb="-2.2rem"
                        padding="0.5rem"
                        position="relative"
                    >
                        {"Return to Game"}
                    </Box>
                    <Box
                        position={'absolute'}
                        top={0}
                        left={0}
                        right={0}
                        bottom={0}
                        z-index={9999}
                    />
                    <Box
                        position="absolute"
                        height="full"
                    />

                </Box>
            )
        }
    }

    const participantList = () => {
        let pList: any[];
        pList = [];
        // if the game hasn't started, the ParticipantList component in Room.tsx should be visible
        // so we don't need to render this
        if (!gameStarted) {
            return pList;
        }
        if (selectedParticipant) {
            pList = participants
                .filter(participant => ((gameStarted && gameFocused) || participant !== selectedParticipant));

        } else if (gameFocused) {
            pList = participants;
        }
        return pList.map(participant => (
                    <Participant
                        key={participant.sid}
                        participant={participant}
                        enableScreenShare
                        onClick={() => changeFocus(participant)}
                    />));

    }

    const localParticipant = () => {
        if (!gameStarted) {
            return (<Participant
                         participant={room?.localParticipant}
                         isLocalParticipant
                     />);
        }
    }

    const childItems = [...participantList(), localParticipant(), gameOverlay()].filter(a => a);
    const numColumns = childItems.length > 1 ? Math.ceil(Math.sqrt(childItems.length)) : 1;
    const numRows = Math.ceil(childItems.length / numColumns);


    // NOTE to future programmers:
    // controlling the size of a grid this way is ugly.
    // But the feature is due, and this works. So here it is.
    return (<SimpleGrid
                alignSelf="flex-end"
                bottom="0.75rem"
                justifySelf="flex-end"
                width={10 * numColumns + "rem"}
                height={6 * numRows + "rem"}
                mr={-12.5 * numColumns + "rem"}
                position="relative"
                right={10 * numColumns + 0.75 + "rem"}
                zIndex="overlay"
                gap={3}
                columns={numColumns}
            >
        {childItems}
    </SimpleGrid>
    )

}

export default CallOverlay;
